import React from 'react'

const Contact = () => {
    return (
        <>
        <div className='max-w-[1200px] mx-auto bg-black sm:py-20 p-5' id='contact'>

            <div className="text-center">
                <h2 className="text-4xl font-bold leading-tight primary-color">Contact Me</h2>
            </div>


            <div className="max-w-[800px] mx-auto">

                <div className="mt-6 bg-[#161616] rounded-xl">
                    <div className="p-10">
                        <form action="https://formkeep.com/f/1f95d3cd9ad4" accept-charset="UTF-8"
                            enctype="multipart/form-data" method='POST'>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">
                                <div>
                                    <div className="mt-2.5">
                                        <input className='bg-[#161616] w-full px-4 py-4 text-gray-400 placeholder-gray-400 border border-gray-700 rounded-md focus:outline-none focus:border-pink-600' type="name" name='name' id='' placeholder='Your Name' />
                                    </div>
                                </div>
                                <div>
                                    <div className="mt-2.5">
                                        <input className='bg-[#161616] w-full px-4 py-4 text-gray-400 placeholder-gray-400 border border-gray-700 rounded-md focus:outline-none focus:border-pink-600' type="email" name='email' id='' placeholder='Your Email' />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <div className="mt-2.5">
                                        <textarea className='bg-[#161616] w-full px-4 py-4 text-gray-400 placeholder-gray-400 border border-gray-700 rounded-md focus:outline-none focus:border-pink-600' type="text" name='message' id='' placeholder='Your Message'></textarea>
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <button className='text-xl w-full p-4 mt-2 font-semibold rounded-md text-white bg-primary-color' type='submit'>Send</button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Contact
